import fetcher from './fetchers'

function parseMobilePath(platform) {
  return platform === 'mobile' ? '/mobile' : '/v1'
}

export const fetchCateList = (params) => {
  return fetcher.post('/wallpaper/live/cate', params)
}

export const fetchStaticCateList = (params) => {
  return fetcher.post('/wallpaper/static/cate', params)
}

export const findTagList = (params) => {
  return fetcher.post('/wallpaper/live/tag/find', params)
}

export const findStaticTagList = (params) => {
  return fetcher.post('/wallpaper/static/tag/find', params)
}

export const doCheckIsExists = (params, platform) => {
  const mobilePath = parseMobilePath(platform)
  return fetcher.post(`${mobilePath}/ugc/check/is_exists`, params)
}

/**
 * 判断用户是否超过上传限制
 * @param {Object} params
 * @param {Object} params.common
 * @param {String} params.common.open_id
 * @param {String} params.common.token
 * @return {Object}
 */
export const doCheckUploadLimit = (params, platform) => {
  const mobilePath = parseMobilePath(platform)
  return fetcher.post(`${mobilePath}/ugc/over/upload/limit`, params)
}

export const doUpload = (data, config, platform) => {
  const mobilePath = parseMobilePath(platform)
  return fetcher.post(`${mobilePath}/ugc/upload`, data, config)
}

/**
 * @description 实名认证 加密上传
 */
export const encryptUpload = (data, config, platform) => {
  const mobilePath = parseMobilePath(platform)
  return fetcher.post(`${mobilePath}/ugc/encrypt/upload`, data, config)
}

export const doCommit = (params, platform) => {
  const mobilePath = parseMobilePath(platform)
  return fetcher.post(`${mobilePath}/ugc/upload/commit`, params)
}

// 获取上传签名
export const getSignUrl = (params, platform) => {
  const mobilePath = parseMobilePath(platform)
  return fetcher.post(`${mobilePath}/ugc/get/sign_url`, params)
}

// upload ali oss
export const uploadApiOss = (file, config) => {
  const params = Object.assign({
    method: 'put',
    data: file,
  }, config)

  return fetcher(params)
}

// 获取资源信息
export const getResource = (params, platform) => {
  const mobilePath = parseMobilePath(platform)
  return fetcher.post(`${mobilePath}/ugc/get/resource`, params)
}

// 【分块上传】初始化
export const uploadMultipartInit = (params, platform) => {
  const mobilePath = parseMobilePath(platform)
  return fetcher.post(`${mobilePath}/ugc/multipart/init`, params)
}

// 【分块上传】上传
export const uploadMultipartUpload = (params, config, platform) => {
  const mobilePath = parseMobilePath(platform)
  return fetcher.post(`${mobilePath}/ugc/multipart/upload`, params, config)
}

// 【分块上传】完成
export const uploadMultipartComplete = (params, config, platform) => {
  const mobilePath = parseMobilePath(platform)
  return fetcher.post(`${mobilePath}/ugc/multipart/complete`, params, config)
}

// 【获取壁纸列表】
export const getPaperList = (params, config) => {
  return fetcher.post('/v1/cms/upload/get_paper_list', params)
}

//  【提交移动端壁纸】
export const submitMobilePaper = (params) => {
  return fetcher.post('/v1/cms/commit_for_mobile', params)
}

//  获取组件列表分类
export const getComponentList = (params) => {
  return fetcher.post('/mobile_composite/category/list', params)
}
